import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "./api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [logo, setLogo] = useState("");
  useEffect(() => {
    if (localStorage.getItem("sanber_token")) {
      api.me().then(setUser).catch(() => {}).finally(() => setLoading(false));
      api.companyLogo().then(r => setLogo(r.logo_image || "")).catch(() => {});
    } else setLoading(false);
  }, []);
  const login = async (username, password) => {
    const r = await api.login({ username, password });
    localStorage.setItem("sanber_token", r.token);
    const me = await api.me();
    setUser(me);
    return r.user;
  };
  const logout = () => { localStorage.removeItem("sanber_token"); setUser(null); window.location.href = "/login"; };
  const can = (area, action) => !!(user && user.permissions && (user.permissions[area] || []).includes(action));
  return <Ctx.Provider value={{ user, loading, login, logout, can, logo }}>{children}</Ctx.Provider>;
}